import Vue from 'vue'

import App from './App.vue'
//import Main from './Main.vue'

import VueRouter from 'vue-router';
import VueHeadful from 'vue-headful';
import VueCookies from 'vue-cookies';

import { globalFormatDate, globalFormatDateShort, globalRusDate, globalRusDateLong } from '../public/utils.js';

Vue.use(VueCookies)

Vue.use(VueRouter)

Vue.component('vue-headful', VueHeadful);

Vue.config.productionTip = false

const routes = [
  //{ path: '/main*', component: Main },
  { path: '*', component: App }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

Vue.mixin({
  data: function () {
    return {
      //nodePort: 4001,
      nbsp: '&nbsp;',
      site_title: 'RP Realms (Realms.ru)',
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    getNodePath() {
      //console.log(this.$router.history.current.fullPath); // will output /index.php?act=Members
      return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/api/"
    },
    getVuePath() {
      if (window.location.port === null || window.location.port === '' || window.location.port === 80 || window.location.port === 443)
        return window.location.protocol + "//" + window.location.hostname + "/";
      else
        return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/";
    },
    htmlDecode(input) {
      let doc = new DOMParser().parseFromString(input, "text/html");
      return doc.documentElement.textContent;
    },
    spanSeconds(dateEarly, dateLater) {
      let delta = Math.abs(dateLater - dateEarly) / 1000;
      return delta;
    },
    fixAvatarPath(path) {
      if (!path || path.length == 0 || path.startsWith("http://"))
        return path;
      return this.publicPath + 'avatars/' + path;
    },
    fixRealmsMainPaths(html) {
      // Finds <a href="/?actions=...", replaces with /main/?actions=...
      // Finds http://www.realms.ru/?actions=..., replaces with /main/?actions=...
      return html.replace(/<a href=['"]\/\?actions(.*?)['"]/gi, function(a, b) {
        console.log("a: " + a);
        return a.replace("/?actions", "/main/?actions");
      }).replace(/<a href=['"]http:\/\/[w]*?\.?realms\.ru\/\?actions(.*?)['"]/gi, function(a, b) {
        return a.replace(".ru/?actions", ".ru/main/?actions");
      });
    },
  },
  filters: {
    formatDate: function(value) {
      return globalRusDate(value);
    },
    formatDateShort: function(value) {
      return globalFormatDateShort(value);
    },
    formatRusDateLong: function(value) {
      return globalRusDateLong(value);
    },
    formatInt: function(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); // formats 4123 to 4.123
    },
    formatAlignment: function(align) {
      switch(align) {
        case 'lg': return 'Lawful Good';
        case 'ln': return 'Lawful Neutral';
        case 'le': return 'Lawful Evil';
        case 'ng': return 'Neutral Good';
        case 'tn': return 'True Neutral';
        case 'ne': return 'Neutral Evil';
        case 'cg': return 'Chaotic Good';
        case 'cn': return 'Chaotic Neutral';
        case 'ce': return 'Chaotic Evil';
        default: return align;
      }
    },
    formatClass: function(cl) {
      switch(cl) {
        case 'bb': return 'Barbarian';
        case 'ba': return 'Bard';
        case 'cl': return 'Cleric';
        case 'dr': return 'Druid';
        case 'fi': return 'Fighter';
        case 'mo': return 'Monk';
        case 'pa': return 'Paladin';
        case 'ra': return 'Ranger';
        case 'ro': return 'Rogue';
        case 'so': return 'Sorcerer';
        case 'wi': return 'Wizard';
        case 'sd': return 'Shadowdancer';
        case 'hs': return 'Harper Scout';
        case 'aa': return 'Arcane Archer';
        case 'as': return 'Assassin';
        case 'bg': return 'Blackguard';
        case 'cot': return 'Champion of Torm';
        case 'wm': return 'Weapon Master';
        case 'pm': return 'Pale Master';
        case 'sh': return 'Shifter';
        case 'dd': return 'Dwarven Defender';
        case 'rdd': return 'Red Dragon Disciple';
        default: return cl;
      }
    }
  }
})

new Vue({
  router
  //render: h => h(Main),
}).$mount('#app')
